module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_16.5ebf65fd.jpg";